import { render, staticRenderFns } from "./AppMainActionsButtonsForm.vue?vue&type=template&id=7c78e37d&scoped=true&"
import script from "./AppMainActionsButtonsForm.vue?vue&type=script&lang=js&"
export * from "./AppMainActionsButtonsForm.vue?vue&type=script&lang=js&"
import style0 from "./AppMainActionsButtonsForm.vue?vue&type=style&index=0&id=7c78e37d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c78e37d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
